import parse from 'html-react-parser'
import { useMemo } from "react";
import { usePublication } from '../../../hooks/usePublication';
import { ButtonsRight } from "../../../interfaces/UI";
import { useParams } from 'react-router-dom';
import { validateImageHttp } from '../../../helpers';

interface Props {
  openButtons : ButtonsRight
  setOpenButtons : ( state : ButtonsRight) => void
}

const CoverPage = ({openButtons, setOpenButtons}: Props) => {
    const {publication, path} = usePublication()
    let { idRevista, idLibro } = useParams();
    const typeLibro: string = idLibro ? "libros" : "revista";
    const urlCoverImg = useMemo(() => validateImageHttp(publication.coverImg, path), [path, publication.coverImg])

    const handleOpenAuthors = () => {
      setOpenButtons({
        ...openButtons,
        optAuthor: true,
        optConfig: false,
        optFileDoc: false,
        optHelp: false,
        optIndex: false,
        optNotes: false,
        optReviews: false,
        optReferences: false
      });
    }

    return (
    <header
      className="content__cover"
      style = {{ backgroundImage: `url(${urlCoverImg})` }}
    >
      <div className='content__logo'>
        <img src={`https://bucketvirtualpro.s3.us-east-1.amazonaws.com/esp/catalogos/${publication.catalogoImg}`} alt=""/>
      </div>
      <div className="content__cover-data show">
        <div className="content__cover-item">
          {/* <div className="vp-label vp-label--feat">
            <div className="vp-label__name">Nueva edición</div>
          </div> */}
          { publication.numero && (<div className="content__cover-edition">Edición N° {publication.numero}</div>) }
          {
              publication.issn?(<>
                <div className="content__cover-issn">{typeLibro === 'libros' ? 'ISBN' : 'ISSN'} {publication.issn}</div>
              </>):null
          }
          { publication.periodo && (<div className="content__cover-date">{publication.periodo}</div>)}
        </div>
        <div className="content__cover-item">
          <h1 className="content__cover-title">{parse(publication.title)}</h1>
          {publication.subtitle?
          <div className="content__cover-txt">
            {publication.subtitle}
          </div>:null
          }

          {
              publication.authors?(
                <div className="content__cover-author" >
                    {
                        publication.authors.map( (author, index) =>(
                            <button className="author__link focus" style={{marginRight: 4}} key={index} onClick={() => {
                              handleOpenAuthors();
                            }}>
                              {author.fullName}
                              {publication.authors && publication.authors?.length > index + 1 ? ',' : ''}
                            </button>
                        ) )
                    }
                </div>
              ):null
          }
        </div>
        <div className="content__cover-item">
          <div className="brand brand--md">
            { (publication.creditsImg && typeLibro !== "libros") && (<img src={`${path}images/${publication.creditsImg}`} alt="Imagen de créditos" />) }
            { publication.creditsLogo && (<img src={`${path}images/${publication.creditsLogo}`} alt="Logo de los créditos" />)}
          </div>
        </div>
      </div>
    </header>
  );
};

export default CoverPage;
